module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node media"
  }, [_c('label', {
    staticClass: "media-left"
  }, [_vm._v(_vm._s(_vm.node.section))]), _vm._v(" "), _c('span', {
    staticClass: "nodes media-body"
  }, _vm._l((_vm.node.data), function(item) {
    return _c('span', {
      key: item.id,
      staticClass: "name"
    }, [_c('router-link', {
      attrs: {
        "title": item.name,
        "to": '/topics?node_id=' + item.id
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f04a7b8c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/NodeItem.vue
// module id = 293
// module chunks = 6